import type { IconData } from '@stacksjs/iconify-core'

export const loopCircular: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M415.313 358.7c36.453-36.452 55.906-85.231 54.779-137.353c-1.112-51.375-21.964-99.908-58.715-136.66l-22.627 22.627a166.82 166.82 0 0 1 49.35 114.725c.937 43.313-15.191 83.81-45.463 114.083l-48.617 49.051l.044-89.165l-32-.016L311.992 440h144.071v-32h-89.614ZM47.937 112h89.614l-48.864 49.3c-36.453 36.451-55.906 85.231-54.779 137.352a198.68 198.68 0 0 0 58.715 136.66l22.627-22.627A166.82 166.82 0 0 1 65.9 297.962c-.937-43.314 15.191-83.811 45.463-114.083l48.617-49.051l-.044 89.165l32 .015L192.008 80H47.937Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default loopCircular
